"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconStyleDesktop = exports.labelStyleDesktop = exports.optionStyleDesktop = exports.titleStyleDesktop = exports.rootStyleDesktop = void 0;

var _emotion = require("emotion");

var rootStyleDesktop =
/*#__PURE__*/
(0, _emotion.css)("position:relative;font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.71;letter-spacing:normal;width:100%;display:-webkit-box;overflow-y:scroll;align-items:center;margin-bottom:20px;&::-webkit-scrollbar{width:0px;background:transparent;height:0px;}");
exports.rootStyleDesktop = rootStyleDesktop;

var titleStyleDesktop = function titleStyleDesktop(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.copper, ";")
  );
};

exports.titleStyleDesktop = titleStyleDesktop;
var optionStyleDesktop =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;margin:0 32px;");
exports.optionStyleDesktop = optionStyleDesktop;

var labelStyleDesktop = function labelStyleDesktop(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.amethyst, ";")
  );
};

exports.labelStyleDesktop = labelStyleDesktop;

var iconStyleDesktop = function iconStyleDesktop(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:10px;height:10px;margin-left:8px;cursor:pointer;align-items:center;display:flex;fill:", theme.color.dark.amethyst, ";")
  );
};

exports.iconStyleDesktop = iconStyleDesktop;